import React from 'react';
import type { OneTimeOrderBundleItem } from './OneTimeOrderModal';
interface BundleBadgeProps {
  className?: string;
}
export function BundleBadge({
  className = ''
}: BundleBadgeProps) {
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-[#E0F2FE] text-[#0369A1] ${className}`} data-id="element-4831" data-mp="1gm74073bzij7">
      Bundle
    </span>;
}
interface BundleContentsProps {
  contents: OneTimeOrderBundleItem[];
}
export function BundleContents({
  contents
}: BundleContentsProps) {
  return <p className="text-[12px] text-[#94A3B8] mt-0.5" data-id="element-4832" data-mp="1ljp89k6el9kv">
      Includes:{' '}
      {contents.map(item => `${item.quantity}x ${item.name}`).join(', ')}
    </p>;
}